module.exports = __webpack_public_path__ + "img/保存3.4a7e4e60.svg";